import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { PageTitle, Loading, Input } from '../root/components/common'
import { NavLink } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from './actions'
import { Table } from '../root/components/common/table'
import { onlyUpdateForKeys } from 'recompose'
import { TableVirtualized } from '../root/components/common/table-virtualized/table-virtualized'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: 'calc(100% - 70px)'
    },
    customerNameLink: {
        ...theme.link
    },
    pageTitle: {
        justifyContent: 'space-between'
    },
    searchInput: {
        width: '25%'
    }
}))

export default function Customers(title) {
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, locale } = useSelector(state => state.main)
    const { softwarePlans, customers, customersFused } = useSelector(
        state => state.customers
    )

    const columns = [
        {
            key: 'name',
            label: locale.common.name,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: true
        },
        {
            key: 'software_plan_id',
            label: locale.customers.plan,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: true
        }
    ]

    const tableCustomRenderer = ({ cellData, columnKey, rowData }) => {
        switch (columnKey) {
            case 'name':
                return (
                    <NavLink
                        className={classes.customerNameLink}
                        to={`/customers/${rowData.id}`}
                    >
                        {cellData}
                    </NavLink>
                )
            case 'software_plan_id':
                return softwarePlans[cellData]
        }
    }

    const onSearch = value => {
        const newCustomers =
            !value || value === ''
                ? customersFused._docs
                : customersFused.search(value).map(data => data.item)
        dispatch(actions.setCustomers(newCustomers))
    }

    useEffect(() => {
        dispatch(actions.getCustomersRequest())
        return () => {
            dispatch(actions.getCustomersSuccess(null))
        }
    }, [])

    const CustomersTableOptimized = onlyUpdateForKeys(['rows'])(
        customersFused &&
            customersFused._docs &&
            customersFused._docs.length < 25
            ? Table
            : TableVirtualized
    )

    return (
        <div className={classes.wrapper}>
            {isLoading && <Loading />}
            {!isLoading &&
                customersFused &&
                customersFused._docs &&
                customersFused._docs.length > 0 && (
                    <React.Fragment>
                        <PageTitle
                            title={locale.customers.customers}
                            className={classes.pageTitle}
                        >
                            <Input
                                autoFocus
                                className={classes.searchInput}
                                label={locale.common.search}
                                type="text"
                                setValue={onSearch}
                                debounce={1000}
                            />
                        </PageTitle>
                        {customers.length > 0 && (
                            <CustomersTableOptimized
                                rows={customers}
                                columns={columns}
                                customRenderer={tableCustomRenderer}
                            />
                        )}
                        {customers.length === 0 && (
                            <div>{locale.customers.noCustomers}</div>
                        )}
                    </React.Fragment>
                )}
            {!isLoading &&
                (!customersFused || customersFused._docs.length === 0) && (
                    <React.Fragment>
                        <div>{locale.customers.noCustomers}</div>
                    </React.Fragment>
                )}
        </div>
    )
}
